import { Field, reduxForm, SubmissionError } from "redux-form";
import { Button, Input } from "expano-components";

import { Dashboard } from "components";

import useUpdate from "hooks/useUpdate";

const InputField = (props) => <Input {...props} />;

const AdditionalData = ({
  product_id,
  refetch,
  handleSubmit,
  pristine,
  invalid,
}) => {
  const { is_updating, update } = useUpdate({
    path: `/products/${product_id}`,
    onSuccess: refetch,
    onError: (err) => {
      throw new SubmissionError(err);
    },
  });

  const onSubmit = (values) => update(values);

  return (
    <Dashboard
      header={{ title: "Etykieta informacyjna", icon: "info" }}
      footer={
        <Button
          type="save"
          text={is_updating ? "Proszę czekać..." : "Zapisz"}
          disabled={pristine || invalid || is_updating}
          onClick={handleSubmit(onSubmit)}
        />
      }
    >
      <form
        className="dashboard__form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
      >
        <Field
          name="instruction_url"
          label="Link do instrukcji"
          component={InputField}
          prefix="www"
          type="text"
        />
      </form>
    </Dashboard>
  );
};

const form = "update-product-additional-data";

export default reduxForm({ form, enableReinitialize: true })(AdditionalData);
